export let content = [
  "kiss",
  "Fashion",
  // "Sports",
  // "Music",
  // "Gaming",
  // "Technology",
  "Health",
  // "Finance",
  "Education",
  "Lifestyle",
  "Travel and Adventure",
  // "Art and Creativity",
  "hugs",
  // "Nature and Wildlife",
  "Food and Culinary",
  // "History and Culture",
  "Fitness and Wellness",
  // "Architecture and Design",
  // "Space and Astronomy",
  "Books and Literature",
  "Motivation and Productivity",
  "Luxury and Lifestyle",
  // "Science and Innovation",
  "bedrooms",
  "romantic",
  "Sibling Love",
  "Date Night",
  // "Valentine",
  "Hobbies and Skills",
  "happy pattern",
  "couples",
  // "bmw-night",
  "Sunsets and Sunrises",
  // "navratri",
  // "Street Photography",
  // "Cute Animals",
  "Quotes and Inspiration",
  "Meditation and Mindfulness",
  // "DIY and Crafts",
  "Festivals and Celebrations",
  // "Adventure Sports",
  // "Cars and Motorcycles",
  // "Gaming Setup",
  // "Music Festivals",
  // "Luxury Cars",
  "Coffee and Cafes",
  "Cityscapes",
  "Nature Trails",
  "Beach Vibes",
  "Snow and Winter",
  // "Street Art",
  "Fashion Accessories",
  "Home Decor",
  "Interior Design",
  "Wedding Moments",
  "Love and Romance",
  "Family Time",
  "Fitness Motivation",
  // "Healthy Recipes",
  // "Travel Destinations",
  // "Cultural Heritage",
  // "Technology Trends",
  "Space Exploration",
  // "Photography Tips",
  // "Pet Love",
  "Nightlife",
  "Vintage Vibes",
  // "Neon Aesthetics",
  // "Minimalism",
  "Boho Style",

  // 👗 Fashion & Lifestyle
  "Fashion Trends",
  // "Street Style",
  "Luxury and Lifestyle",
  "Minimalist Aesthetics",
  // "Boho Style",
  "Fashion Accessories",
  "Makeup and Beauty",
  "Home Decor",
  "Interior Design",
  "Modern Bedrooms",
  "Workspace Inspiration",

  // 🏞️ Nature & Travel
  // "Nature and Wildlife",
  "Beach Vibes",
  "Sunsets and Sunrises",
  "Mountain Views",
  "Rainy Days",
  "Snow and Winter",
  "Nature Trails",
  "Adventure Travel",
  "Road Trips",
  // "Cultural Heritage",
  "Cityscapes",
  "Skyline Views",
  "Desert Landscapes",
  "Tropical Paradise",
  // "Space and Astronomy",

  // 🎨 Art & Creativity
  "Art and Creativity",
  "DIY and Crafts",
  "Photography Inspiration",
  // "Street Art",
  // "Abstract Art",
  "Color Palettes",
  // "Typography Design",
  "Digital Art",
  // "Painting Textures",

  // 🧠 Motivation & Learning
  "Motivation and Productivity",
  "Quotes and Inspiration",
  "Self Growth",
  "Books and Literature",
  "Education and Learning",
  "Mindfulness and Meditation",
  // "Focus and Study Setup",
  

  // 🏋️ Health & Fitness
  // "Fitness and Wellness",
  // "Healthy Recipes",
  // "Workout Motivation",
  // "Yoga and Meditation",
  // "Mental Health Awareness",
  // "Sleep and Recovery",

  // 🚀 Tech & Modern Life
  // "Technology Trends",
  // "AI and Innovation",
  // "Science and Discovery",
  // "Gaming Setup",
  // "Coding Aesthetics",
  // "Gadgets and Devices",
  "Digital Nomad Life",
  // "Futuristic Designs",

  // 🚗 Cars & Lifestyle
  // "Cars and Motorcycles",
  // "Luxury Cars",
  "BMW Night",
  // "Vintage Cars",
  // "Street Racing",
  // "Garage Goals",

  // ☕ Everyday Aesthetic Vibes
  "Coffee and Cafes",
  "Books and Coffee",
  "Aesthetic Desks",
  // "Cozy Corners",
  "Rain Window",
  "Morning Light",
  "Night Lights",
  // "Neon Aesthetics",
  "Vintage Vibes",
  // "Happy Patterns",

  // 🥳 Events & Culture
  "Festivals and Celebrations",
  "Navratri",
  "Diwali Lights",
  "Christmas Decor",
  // "New Year Party",
  // "Cultural Dances",
  "Wedding Moments",
  // "Street Photography",

  // 🐾 Animals
  // "Pet Love",
  // "Cute Animals",
  // "Wildlife Moments",
  // "Bird Photography",

  // ⚡ Misc / Trending
  "Adventure Sports",
  "Space Exploration",
  "Minimalism",
  // "Photography Tips",
  "Luxury Interiors",
  "Creative Portraits",

  // 💞 Emotions & Relationships
  "Love and Romance",
  "Couples",
  "Sibling Love",
  "Family Time",
  // "Friendship Goals",
  "Romantic Moments",
  "Date Night",
  "Hugs and Kisses",
  "Cute Gestures",

  "nails-paints",

    //update new catgeoyr below on 31-01-2026
    "Soft Minimal Interiors",
    "Window Light",
    "Morning Calm",    
    //updated new catgeoyr for the mornign time 

    "Sunrises",
    "Morning Light",
    "Nature Trails",
    "Fitness Motivation",
    "Mindfulness and Meditation",
    // "Healthy Recipes",
    "Coffee and Cafes",
    "Morning Routines",
    
   "Soft Minimal Interiors",
   "Window Light",
    "Morning Calm",
   "Night Calm",
    // "Bedroom Mood",
    "Minimal Night Aesthetic",
    "Quiet Streets",

    //update new evening category  below on 05-02-2026 
       "Golden Hour",
    "Love and Romance",
    "Couples",
    "Date Night",
    // "Street Art",
    "evenings",
    "evening-home",
    "sunsets",
      "Fashion Accessories",
  "Makeup and Beauty",
  "Home Decor",
  "Interior Design",
  // "Modern Bedrooms",
  "recipes",

    //update new catgeoyr below on 31-01-2026
  "Cozy Lighting",
  "Soft Interiors",
  "Home Evenings",

  //update new night category  below on 05-02-2026 

     "Nightlife",
    // "Neon Aesthetics",
    "City Lights",
    // "Vintage Vibes",
    // "Space Exploration",
    "Moody Aesthetic",
    "Romantic Moments",
    "night-lights",

    //update new catgeoyr below on 31-01-2026
    "Night Calm",
    "Bedroom Mood",
    "Minimal Night Aesthetic",
    "Quiet Streets",




    
  "Sunny Balconies",
  "Balcony Plants",
  "Sunlit Living Rooms",
  "Window Sunlight",
  "Afternoon Coffee",
  "Cozy Balcony",
  "Home Plants",
  "Sunlight Curtains",
  "Warm Home Interiors",
  "Relaxing Afternoons",
  "Balcony Views",
  "Lazy Afternoon"


  
];

export const timeBasedContent = {
  morning: [
    "Sunrises",
    "Morning Light",
    "Nature Trails",
    "Fitness Motivation",
    "Mindfulness and Meditation",
    // "Healthy Recipes",
    
    

  //update new catgeoyr below on 31-01-2026
   "Soft Minimal Interiors",
   "Window Light",
    "Morning Calm",
   
    // "Bedroom Mood",
    "Minimal Night Aesthetic",
    "Quiet Streets"

  ],

 afternoon: [
  "Sunny Balconies",
  "Balcony Plants",
  "Sunlit Living Rooms",
  // "Afternoon Coffee",
  "Home Plants",
  "Warm Home Interiors",
  "Balcony Views",
  "Lazy Afternoon"
],

 evening: [
  "Golden Hour",
  "Sunsets",
  "Love and Romance",
  "Couples",
  "Date Night",
  "Fashion",
  "Makeup and Beauty",
  "Home Decor",
  "Interior Design",
  "Cozy Lighting",
  "Recipes",
  "lamp-lights-mood"
  // "Food Photography",
],

  night: [
   "City Lights",
  "Romantic Moments",
  "Couples",
  "Holding Hands",
  "Date Night",
  "Love at Night",
  "Night Walks",
  "Bedroom Aesthetic",
  "Moody Aesthetic",
  "Nightlife"
  ]
};


export const timeCategoryResolver = {
  // 🌅 Morning
  "Sunrises": "Sunsets and Sunrises",
  "Morning Light": "Morning Light",
  "Nature Trails": "Nature Trails",
  "Fitness Motivation": "Fitness Motivation",
  "Mindfulness and Meditation": "Mindfulness and Meditation",
  "Coffee and Cafes": "Coffee and Cafes",
  "Morning Routines": "Lifestyle",
  "Soft Minimal Interiors": "Minimalist Aesthetics",
  "Window Light": "Morning Light",
  "Morning Calm": "Mindfulness and Meditation",

  // ☀️ Afternoon
  // "Workspace Inspiration": "Workspace Inspiration",
  // "Design and Creativity": "Art and Creativity",
  // "Coding Aesthetics": "Digital Art",
  // "Photography Tips": "Photography Inspiration",
  // "Minimal Workspaces": "Workspace Inspiration",
  // "Creative Process": "Motivation and Productivity",
  // "Warm Tones": "Color Palettes",
  // "Desk Flatlays": "Aesthetic Desks",
  // "nails-paints": "nails-paints",

 

  "Sunny Balconies": "Home Decor",
"Balcony Plants": "Home Decor",
"Sunlit Living Rooms": "Interior Design",
"Window Sunlight": "Morning Light",
"Afternoon Coffee": "Coffee and Cafes",
"Cozy Balcony": "Home Decor",
"Home Plants": "Home Decor",
"Sunlight Curtains": "Interior Design",
"Warm Home Interiors": "Interior Design",
"Relaxing Afternoons": "Lifestyle",
"Balcony Views": "Cityscapes",
"Lazy Afternoon": "Lifestyle",



  // 🌇 Evening
  "Golden Hour": "Sunsets and Sunrises",
  "Couples": "Couples",
  "Date Night": "Date Night",
  "Love and Romance": "Love and Romance",
  "Fashion Accessories": "Fashion Accessories",
  "Makeup and Beauty": "Makeup and Beauty",
  "Home Decor": "Home Decor",
  "Interior Design": "Interior Design",
  "Cozy Lighting": "Luxury Interiors",
  "Soft Interiors": "Luxury Interiors",
  "Home Evenings": "Home Decor",

  // 🌙 Night
  "Nightlife": "Nightlife",
  "City Lights": "Cityscapes",
  "Moody Aesthetic": "Vintage Vibes",
  "Romantic Moments": "Romantic Moments",
  "night-lights": "Night Lights",
  "Night Calm": "Minimalism",
  "Bedroom Mood": "Modern Bedrooms",
  "Minimal Night Aesthetic": "Minimalist Aesthetics",
  "Quiet Streets": "Cityscapes"
};




export const fallbackKeywords = [
  "4k wallpaper",
  "nature",
  "travel",
  "aesthetic",
  "ultra hd",
  "city night",
  "mountains",
  "flowers",
  // "abstract art"
  "sunsets",
  
    
  "Sunny Balconies",
  "Balcony Plants",
  "Sunlit Living Rooms",
  "Window Sunlight",
  "Afternoon Coffee",
  "Cozy Balcony",
  "Home Plants",
  "Sunlight Curtains",
  "Warm Home Interiors",
  "Relaxing Afternoons",
  "Balcony Views",
  "Lazy Afternoon"
];

export const aestheticMods = [
  "aesthetic",
  "beautiful",
  "stunning",
  "dreamy",
  "vibrant",
  "colorful",
  "minimal"
];

export const sceneMods = [
  "landscape",
  "nature",
  "background",
  "outdoor",
  "close-up",
  "macro"
];

export const timeMods = [
  "sunset",
  "sunrise",
  "golden hour",
  "morning",
  "night"
];

export const styleMods = [
  "photography",
  "wallpaper",
  "background",
  "inspiration"
];


// export const topicHub = {

//   sunset: [
//     "golden-sunset-reflections",
//     "purple-sunset-horizon",
//     "dreamy-evening-horizon",
//     "tropical-sunset-mood",
//     "orange-sky-waves",
//     "calm-ocean-dusk",
//     "pink-sunset-clouds",
//     "cinematic-sunset-view"
//   ],

//   nature: [
//     "green-nature-aesthetic",
//     "misty-forest-vibes",
//     "calm-river-view",
//     "peaceful-mountain-scenery",
//     "dreamy-nature-walk",
//     "sunlight-through-trees",
//     "fresh-morning-nature",
//     "wild-nature-landscape"
//   ],

//   flowers: [
//     "dreamy-flower-aesthetic",
//     "pink-water-lily",
//     "calm-rose-garden",
//     "cherry-blossom-vibes",
//     "purple-flower-field",
//     "misty-floral-mood",
//     "soft-petal-closeup",
//     "sunlight-flower-bloom"
//   ],

//   ocean: [
//     "calm-ocean-waves",
//     "tropical-beach-evening",
//     "deep-blue-sea",
//     "cinematic-ocean-view",
//     "dreamy-water-horizon",
//     "peaceful-seaside-vibes",
//     "sunset-ocean-reflections",
//     "crystal-clear-water"
//   ],

//   sky: [
//     "purple-evening-sky",
//     "dreamy-cloudscape",
//     "golden-sky-horizon",
//     "pink-sky-aesthetic",
//     "calm-sunset-clouds",
//     "cinematic-night-sky",
//     "soft-morning-sky",
//     "orange-evening-glow"
//   ],
//    laptop: [
//     "work-from-home",
//     "remote-workspace",
//     "modern-office",
//     "digital-nomad",
//     "productivity-desk",
//     "business-lifestyle",
//     "home-office-setup",
//     "tech-workspace"
//   ],

//   woman: [
//     "women-lifestyle",
//     "fashion-photography",
//     "casual-portraits",
//     "confident-woman",
//     "modern-lifestyle",
//     "outdoor-portraits",
//     "creative-people",
//     "lifestyle-photography"
//   ],

//   water: [
//     "water-drops",
//     "water-ripples",
//     "water-texture",
//     "clear-water",
//     "blue-water",
//     "water-background",
//     "liquid-art",
//     "water-photography"
//   ],

//     animal: [
//     "cute-animals",
//     "wildlife",
//     "animal-photography",
//     "nature-animals",
//     "animal-closeup",
//     "pets",
//     "forest-animals",
//     "animal-wallpapers"
//   ],
//   forest: [
//   "misty-forest-trail",
//   "woodland-path",
//   "sunlight-through-trees",
//   "forest-river",
//   "forest-cabin",
//   "green-canopy",
//   "nature-walk",
//   "forest-photography"
// ],

// lake: [
//   "mountain-lake",
//   "sunset-lake",
//   "calm-lakeside",
//   "lake-reflections",
//   "lake-photography",
//   "wooden-pier",
//   "peaceful-water",
//   "nature-lake"
// ],
// tree: [
//   "ancient-trees",
//   "forest-canopy",
//   "tree-lined-road",
//   "autumn-trees",
//   "green-woodland",
//   "nature-landscape",
//   "sunlight-through-trees",
//   "tree-photography"
// ],

// street: [
//   "city-street",
//   "urban-lifestyle",
//   "street-photography",
//   "night-city-lights",
//   "historic-town",
//   "busy-crosswalk",
//   "cityscape",
//   "urban-exploration"
// ],

// stone: [
//   "stone-pathway",
//   "historic-architecture",
//   "rock-formations",
//   "stone-bridge",
//   "mountain-rocks",
//   "nature-textures",
//   "stone-wall",
//   "outdoor-landscape"
// ],
// camera: [
//   "photography-gear",
//   "travel-photography",
//   "camera-closeup",
//   "creative-photography",
//   "professional-camera",
//   "photo-studio",
//   "street-photography",
//   "camera-lifestyle"
// ],
// bird: [
//   "colorful-birds",
//   "birds-on-branches",
//   "wildlife-photography",
//   "forest-birds",
//   "flying-birds",
//   "bird-closeup",
//   "nature-birding",
//   "rare-bird-species"
// ],

// beach: [
//   "tropical-beach",
//   "beach-sunset",
//   "beach-vacation",
//   "coastal-waves",
//   "beach-photography",
//   "summer-beach",
//   "ocean-shore",
//   "seaside-relaxation"
// ],

// boat: [
//   "ocean-cruise",
//   "sailing-adventure",
//   "sunset-boat",
//   "coastal-travel",
//   "water-journey",
//   "sea-exploration",
//   "yacht-lifestyle",
//   "marine-photography"
// ],

// cat: [
//   "cute-cat",
//   "sleeping-cat",
//   "cat-closeup",
//   "pet-photography",
//   "playful-kitten",
//   "indoor-cat",
//   "cat-portrait",
//   "animal-companion"
// ],

// dog: [
//   "cute-dog",
//   "dog-portrait",
//   "outdoor-dog",
//   "playful-puppy",
//   "pet-photography",
//   "dog-closeup",
//   "happy-pet",
//   "animal-friend"
// ]

// };



export const topicHub = {
  sunset: [
    "ocean-sunset",
    "beach-sunset",
    "pink-sunset-sky",
    "golden-hour",
    "sunset-wallpaper",
    "sunset-photography",
    "sunset-clouds",
    "tropical-sunset"
  ],

  nature: [
    "nature-wallpapers",
    "mountain-views",
    "forest-path",
    "river-landscape",
    "waterfall-views",
    "green-scenery",
    "nature-photography",
    "peaceful-nature"
  ],

  flowers: [
    "rose-garden",
    "cherry-blossoms",
    "flower-wallpapers",
    "pink-flowers",
    "flower-photography",
    "spring-flowers",
    "wildflowers",
    "beautiful-blooms"
  ],

  ocean: [
    "ocean-waves",
    "beach-wallpapers",
    "tropical-beach",
    "blue-ocean",
    "sea-photography",
    "coastal-sunset",
    "ocean-view",
    "summer-beach"
  ],

  sky: [
    "sunset-sky",
    "pink-clouds",
    "night-sky",
    "cloud-photography",
    "blue-sky",
    "sky-wallpapers",
    "golden-sky",
    "dramatic-clouds"
  ],

  laptop: [
    "work-from-home",
    "home-office",
    "desk-setup",
    "remote-work",
    "productivity-setup",
    "workspace-design",
    "office-inspiration",
    "digital-nomad"
  ],

  woman: [
    "women-fashion",
    "lifestyle-photography",
    "portrait-photography",
    "fashion-inspiration",
    "modern-woman",
    "street-style",
    "casual-fashion",
    "creative-portraits"
  ],

  water: [
    "water-drops",
    "ocean-waves",
    "water-textures",
    "blue-water",
    "water-backgrounds",
    "water-photography",
    "clear-water",
    "water-reflections"
  ],

  animal: [
    "cute-animals",
    "animal-wallpapers",
    "wildlife-photography",
    "baby-animals",
    "pet-photography",
    "animal-portraits",
    "nature-animals",
    "forest-animals"
  ],

  forest: [
    "forest-path",
    "forest-wallpapers",
    "nature-trails",
    "woodland-views",
    "forest-photography",
    "green-forest",
    "forest-river",
    "forest-cabin"
  ],

  lake: [
    "lake-sunset",
    "mountain-lake",
    "lake-reflections",
    "lakeside-view",
    "nature-lake",
    "peaceful-water",
    "lake-photography",
    "wooden-pier"
  ],

  tree: [
    "autumn-trees",
    "tree-lined-road",
    "forest-trees",
    "nature-landscape",
    "green-woodland",
    "tree-photography",
    "beautiful-trees",
    "sunlight-through-trees"
  ],

  street: [
    "street-photography",
    "city-lights",
    "urban-lifestyle",
    "city-streets",
    "historic-town",
    "cityscape",
    "night-city",
    "urban-exploration"
  ],

  stone: [
    "stone-bridge",
    "rock-formations",
    "historic-architecture",
    "mountain-rocks",
    "stone-path",
    "nature-textures",
    "stone-wall",
    "outdoor-landscapes"
  ],

  camera: [
    "camera-gear",
    "photography-tips",
    "professional-camera",
    "travel-photography",
    "creative-photography",
    "photo-studio",
    "camera-closeup",
    "street-photography"
  ],

  bird: [
    "bird-photography",
    "colorful-birds",
    "flying-birds",
    "wildlife-birds",
    "bird-wallpapers",
    "forest-birds",
    "bird-closeups",
    "rare-birds"
  ],

  beach: [
    "beach-sunset",
    "tropical-beach",
    "beach-wallpapers",
    "summer-beach",
    "ocean-shore",
    "coastal-waves",
    "beach-vacation",
    "seaside-view"
  ],

  boat: [
    "sailing-boats",
    "sunset-boat",
    "ocean-cruise",
    "yacht-lifestyle",
    "coastal-travel",
    "boat-photography",
    "sea-adventure",
    "water-journey"
  ],

  cat: [
    "cute-kittens",
    "cat-wallpapers",
    "sleeping-cats",
    "funny-cats",
    "fluffy-cats",
    "cat-portraits",
    "playful-kittens",
    "indoor-cats"
  ],

  dog: [
    "cute-dogs",
    "puppy-photos",
    "dog-wallpapers",
    "happy-dogs",
    "playful-puppies",
    "dog-portraits",
    "pet-dogs",
    "outdoor-dogs"
  ]
};


export const ImageHeading = {
  sunset: {
    title: "Beautiful Sunset Collection",
    subtitle: "Golden skies, peaceful evenings, and breathtaking sunsets."
  },

  ocean: {
    title: "Beautiful Ocean Images",
    subtitle: "Explore beaches, waves, and stunning ocean views."
  },

  beach: {
    title: "Beautiful Beach Collection",
    subtitle: "Tropical beaches, soft sand, and coastal escapes."
  },

  nature: {
    title: "Nature Inspiration",
    subtitle: "Peaceful landscapes, forests, mountains, and rivers."
  },

  flowers: {
    title: "Beautiful Flower Collection",
    subtitle: "Fresh blooms, colorful gardens, and floral photography."
  },

  woman: {
    title: "Women's Fashion Inspiration",
    subtitle: "Portraits, fashion, and aesthetic photography."
  },

  laptop: {
    title: "Workspace Inspiration",
    subtitle: "Modern desk setups and productive workspaces."
  },

  sky: {
    title: "Beautiful Sky Collection",
    subtitle: "Sunsets, clouds, stars, and colorful skies."
  },

  forest: {
    title: "Forest Inspiration",
    subtitle: "Woodland paths, green forests, and peaceful scenery."
  },

  lake: {
    title: "Beautiful Lake Views",
    subtitle: "Calm waters, reflections, and scenic lakes."
  },

  cat: {
    title: "Cute Cat Collection",
    subtitle: "Adorable kittens and beautiful cat photography."
  },

  dog: {
    title: "Cute Dog Collection",
    subtitle: "Happy puppies and heartwarming dog photos."
  },

  animal: {
    title: "Wildlife Collection",
    subtitle: "Discover beautiful animals from around the world."
  }, 
  bedroom: {
  title: "Modern Bedroom Inspiration",
  subtitle: "Discover cozy bedrooms, stylish interiors, and beautiful room design ideas."
},
};

const natureKeywords = [
  "nature",
  "sunset",
  "sunrise",
  "ocean",
  "beach",
  "sea",
  "forest",
  "tree",
  "trees",
  "leaf",
  "leaves",
  "mountain",
  "mountains",
  "lake",
  "river",
  "waterfall",
  "flower",
  "flowers",
  "garden",
  "sky",
  "cloud",
  "clouds",
  "autumn",
  "spring",
  "summer",
  "winter",
  "landscape",
  "wildlife"
];


function normalizeText(value = "") {
  return decodeURIComponent(String(value))
    .toLowerCase()
    .replace(/[-_+/]+/g, " ")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function tokenizeText(value = "") {
  return normalizeText(value)
    .split(" ")
    .filter(Boolean)
    .map(normalizeWord)
    .filter(Boolean);
}

function normalizeWord(word = "") {
  word = word.toLowerCase().trim();

  if (!word) return "";

  // couples -> couple
  if (word.endsWith("ies") && word.length > 4) {
    return word.slice(0, -3) + "y";
  }

  // cars -> car
  // dogs -> dog
  // couples -> couple
  if (word.endsWith("s") && !word.endsWith("ss")) {
    return word.slice(0, -1);
  }

  return word;
}

export function isNatureQuery(query) {
  if(!query) return false
  const normalizedQuery = normalizeText(query);
  const queryTokens = tokenizeText(normalizedQuery);

  return natureKeywords.some(keyword => {
    const keywordTokens = tokenizeText(keyword);

    return keywordTokens.every(token =>
      queryTokens.includes(token)
    );
  });
}
